<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition ease-out duration-300"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition ease-in duration-200"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div v-if="modelValue" class="fixed inset-0 z-50 overflow-y-auto">
        <!-- Backdrop with blur -->
        <div class="flex min-h-screen items-center justify-center">
          <div 
            class="fixed inset-0 bg-gray-900/90 backdrop-blur-sm" 
            @click="$emit('update:modelValue', false)"
          ></div>

          <!-- Modal panel -->
          <Transition
            enter-active-class="transition ease-out duration-300 transform"
            enter-from-class="opacity-0 translate-y-8"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition ease-in duration-200 transform"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 translate-y-8"
          >
            <div v-if="modelValue" :style="`max-width: ${maxWidth}`" class="relative w-full max-w-lg transform rounded-xl bg-gradient-to-b from-dark-secondary/95 to-dark/95 text-left shadow-2xl ring-1 ring-gray-700/50">
              <!-- Header -->
              <div class="border-b border-gray-700/50 px-6 py-4">
                <h3 class="text-lg font-medium leading-6 text-gray-100">
                  <slot name="title"></slot>
                </h3>
              </div>

              <!-- Content -->
              <div class="px-6 py-4">
                <div class="space-y-4">
                  <slot></slot>
                </div>
              </div>

              <!-- Footer -->
              <div class="border-t border-gray-700/50 bg-dark/30 px-6 py-4 sm:flex sm:flex-row-reverse sm:gap-2">
                <slot name="footer"></slot>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean
  maxWidth?: string
}>()

defineEmits(['update:modelValue'])
</script>